import { Component, DestroyRef, inject, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { AppService } from '@app/app.service';
import { SharedConstants } from '@app/shared/constants';
import { EventService } from '@common/event.service';
import { IdentityUserService } from '@identity/identity-user.service';

const LOGO_TITLE_KEY = 'LOGO_TITLE';
const HEADER_HTML_KEY = 'HEADER_HTML';
const PATH = '../../../assets/images/';


@Component({
    selector: 'header-content',
    standalone: true,
    imports: [RouterModule],
    templateUrl: './header-content.component.html',
    styleUrl: './header-content.component.scss',
    encapsulation: ViewEncapsulation.None
})

export class HeaderContentComponent {
    private appService = inject(AppService);
    private identityUserService = inject(IdentityUserService);
    private sanitizer = inject(DomSanitizer);
    private eventService = inject(EventService);
    private destroyRef = inject(DestroyRef);

    private RELOAD_HEADER_EVENT = SharedConstants.RELOAD_HEADER_EVENT;
    isDefaultTemplate: boolean = true;
    pathToLogo = '';
    isLogged = false;
    headerHTML: SafeHtml = '';

    constructor() {
        this.eventService.getEvent(this.RELOAD_HEADER_EVENT)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((ev) => {
                this.loadHeaderContent();
            });
    }

    ngOnInit() {
        this.isLogged = this.identityUserService.isLogged();
        this.loadHeaderContent();
    }

    private loadHeaderContent() {
        const logoName = this.appService.getConfigurationRaw(LOGO_TITLE_KEY) || 'agile-logo.png';
        if (logoName !== null && logoName.indexOf("http") === -1) {
            this.pathToLogo = PATH + logoName;
        } else if (logoName !== null) {
            this.pathToLogo = logoName;
        }

        const headerContent = this.appService.getConfigurationRaw(HEADER_HTML_KEY) || '';
        if (headerContent.length === 0) {
            this.isDefaultTemplate = true;
            this.headerHTML = '';
        } else {
            this.isDefaultTemplate = false;
            this.headerHTML = this.sanitizer.bypassSecurityTrustHtml(headerContent);
        }
    }

    ngAfterViewInit() {
        this.showHideElements(this.isLogged);
    }

    showHideElements(isLogged: boolean) {
        let elementsNotLogged = document.querySelectorAll('.header-isnotlogged');
        let elementsLogged = document.querySelectorAll('.header-islogged');
        if (isLogged && (elementsLogged.length || elementsNotLogged.length)) {
            this._showElements(elementsLogged);
            this._hideElements(elementsNotLogged);
        }
        else if (!isLogged && (elementsLogged.length || elementsNotLogged.length)) {
            this._showElements(elementsNotLogged);
            this._hideElements(elementsLogged);
        }
    }

    _showElements(elements: any) {
        elements.removeClass('hidden')
    }
    _hideElements (elements : any) {
        elements.addClass('hidden')
    }
}
